<nav class="sidebar-nav">

  <!-- Brand Header -->
  <div class="sidebar-brand" (click)="goToHome()">
    <div class="sidebar-brand__logo">
      <svg width="34" height="34" viewBox="0 0 44 44" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id="sidebarBagGrad" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
            <stop stop-color="#3E79CE" /><stop offset="1" stop-color="#699F53" />
          </linearGradient>
        </defs>
        <path d="M9 19 C8.4 19 7.9 19.5 7.8 20.1 L6.2 38 Q6.1 39.5 7.6 39.5 L36.4 39.5 Q37.9 39.5 37.8 38 L36.2 20.1 C36.1 19.5 35.6 19 35 19 Z" fill="url(#sidebarBagGrad)" />
        <path d="M16.5 19 C16.5 12 27.5 12 27.5 19" stroke="url(#sidebarBagGrad)" stroke-width="2.5" fill="none" stroke-linecap="round" />
        <path d="M15 29.5 L20.5 35 L30 23" stroke="white" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <span class="brand-name">PickMe<span class="pmr-gradient-text">Right</span></span>
  </div>

  <!-- Account bar — role switcher, only rendered for accounts that actually
       have more than one role. This is the single global place it lives,
       since the sidebar is present on every authenticated page. -->
  @if (canSwitchRole) {
    <div class="nav-section-label">Switch Role</div>
    <div class="sidebar-account-bar">
      <app-role-switcher></app-role-switcher>
    </div>
  }

  <!-- Section label -->
  <div class="nav-section-label">Menu</div>

  <ul class="nav flex-column nav-list">

    @for (item of filteredMenuItems; track item.label) {

      <!-- Divider before login/logout -->
      @if (item.label === 'Login') {
        <li class="nav-divider" role="separator"></li>
      }

      <li class="nav-item">

        <!-- ── LOGIN / LOGOUT leaf ───────────────────────────────────────── -->
        @if (item.isLeafNode && item.label === 'Login') {
          <a
            class="nav-link"
            [class.logout-link]="isLoggedIn()"
            (click)="onLeafClick(item)"
            role="button">
            @if (item.icon) {
              <span class="nav-icon"><fa-icon [icon]="item.icon"></fa-icon></span>
            }
            <span class="nav-label">{{ isLoggedIn() ? 'Logout' : 'Login' }}</span>
          </a>
        }

        <!-- ── Regular leaf with route ──────────────────────────────────── -->
        @else if (item.isLeafNode && item.route) {
          <a
            [routerLink]="item.route"
            [class.active]="isMenuItemActive(item)"
            class="nav-link">
            @if (item.icon) {
              <span class="nav-icon"><fa-icon [icon]="item.icon"></fa-icon></span>
            }
            <span class="nav-label">{{ item.label }}</span>
          </a>
        }

        <!-- ── Non-leaf: render children ───────────────────────────────── -->
        @else if (!item.isLeafNode && item.children?.length) {
          <ul class="nav flex-column">
            @for (child of item.children; track child.label) {
              <li class="nav-item">
                <a
                  [routerLink]="child.route"
                  [class.active]="isMenuItemActive(child)"
                  class="nav-link">
                  @if (child.icon) {
                    <span class="nav-icon"><fa-icon [icon]="child.icon"></fa-icon></span>
                  }
                  <span class="nav-label">{{ child.label }}</span>
                </a>
              </li>
            }
          </ul>
        }

      </li>
    }

  </ul>
</nav>